<template>
  <div class="myReceiveResumeIndex">
    <div class="bannercont">
      <div class="banner1" v-show="bannerlist.length > 0">
        <el-carousel :interval="5000" arrow="always" :height="'16vw'">
          <el-carousel-item v-for="item in bannerlist" :key="item.id" fit="cover">
            <el-image class="imgg" :src="item.code" @click="goPage(item.value)" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="banner2" v-show="bannerLists.length > 0">
        <el-image v-for="item in bannerLists" :key="item.id" fit="cover" class="imgg" :src="item.code"
          @click="goPage(item.value)" />
      </div>
    </div>
    <div class="cont">
      <div class="selectCont">
        <el-select v-model="jobName" placeholder="全部职位" filterable @change="selectJob">
          <el-option v-for="item in jobList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-radio-group v-model="resumeStatus" @change="changeResumeStatus">
          <el-radio-button label="1">待处理({{ statusCount[0].statusNum }})</el-radio-button>
          <el-radio-button label="2">接收({{ statusCount[1].statusNum }})</el-radio-button>
          <el-radio-button label="3">推荐客户({{ statusCount[2].statusNum }})</el-radio-button>
          <el-radio-button label="4">已面试({{ statusCount[3].statusNum }})</el-radio-button>
          <el-radio-button label="5">已发offer({{ statusCount[4].statusNum }})</el-radio-button>
          <el-radio-button label="6">已入职({{ statusCount[5].statusNum }})</el-radio-button>
          <el-radio-button label="7">过保({{ statusCount[6].statusNum }})</el-radio-button>
          <el-radio-button label="99">激活({{ statusCount[7].statusNum }})</el-radio-button>
          <el-radio-button label="100">淘汰</el-radio-button>
        </el-radio-group>
        <el-pagination style="margin: 30px auto 0 auto; text-align: center;" @current-change="getResumeList()"
          :current-page.sync="resumePageNum" :page-size.sync="resumePageSize" layout="total, prev, next, jumper" :total="resumePageTotle">
        </el-pagination>
        <div v-bind:class="item.id === setid ? 'resitem resitemactive' : 'resitem'" v-for="item in resumeList"
          :key="item.id" @click="getResInfo(item.id)">
          <div class="p1">{{ item.name }}</div>
          <div class="p2">投递：{{ item.positionName }}</div>
          <div class="p3">{{ item.xsTime }}</div>
        </div>
      </div>
      <div class="tableCont" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)">
        <div v-if="resumeList.length === 0">暂无简历</div>
        <div v-if="setitem && resumeList.length > 0">
          <div class="name">{{ setitem.name }}</div>
          <div class="bt">职位推荐</div>
          <div class="item">
            <div class="p1">职位名称：</div>
            <div class="p2">{{ setitem.positionName }}</div>
          </div>
          <div class="item">
            <div class="p1">公司简称：</div>
            <div class="p2">{{ setitem.customCompanyName }}</div>
          </div>
          <div class="item">
            <div class="p1">推荐顾问：</div>
            <div class="p2">{{ setitem.adviserName }}</div>
          </div>
          <div class="item">
            <div class="p1">职位佣金：</div>
            <div class="p2">
              {{
                ((setitem.minYearSalary + setitem.maxYearSalary) * 9) / 120 +
                ' w'
              }}
            </div>
          </div>
          <div class="item">
            <div class="p1">顾问微信：</div>
            <div class="p2">{{ setitem.acWeixin }}</div>
          </div>
          <div class="item">
            <div class="p1">顾问电话：</div>
            <div class="p2">{{ setitem.phone }}</div>
          </div>
          <div class="item">
            <div class="p1">简历附件：</div>
            <div class="p3" @click="openPdf(setitem.oldFileUrl)">
              点击查看简历
            </div>
            <div class="p3" @click="download(setitem)">下载简历</div>
          </div>
          <div class="bt">推荐进度</div>
          <div class="linebox">
            <div class="line">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="drawline" v-bind:style="{ width: mwidth[`${setitem.status}`] }"></div>
            </div>
            <div class="textline">
              <div v-bind:class="t">待处理</div>
              <div v-bind:class="`t ${setitem.status === 1 ? '' : ''}`">
                接收
              </div>
              <div v-bind:class="`t ${setitem.status === 2 ? '' : ''}`">
                推荐客户
              </div>
              <div v-bind:class="`t ${setitem.status === 3 ? '' : ''}`">
                已面试
              </div>
              <div v-bind:class="`t ${setitem.status === 4 ? '' : ''}`">
                已发offer
              </div>
              <div v-bind:class="`t ${setitem.status === 5 ? '' : ''}`">
                已入职
              </div>
              <div v-bind:class="`t ${setitem.status === 6 ? '' : ''}`">
                过保
              </div>
            </div>
          </div>
          <div class="btnbox">
            <div v-if="setitem.status === 1" v-bind:class="`t active`" @click="flag(2)">
              接收
            </div>
            <div v-if="setitem.status !== 1" v-bind:class="`t `">
              接收
            </div>

            <div v-if="setitem.status === 2 &&
              (setitem.jobCandidateStatusEVoList.length === 0 ||
                (setitem.jobCandidateStatusEVoList.length > 0 &&
                  setitem.jobCandidateStatusEVoList[0].type !== 1))" v-bind:class="`t active`" @click="flag(3)">
              推荐客户
            </div>
            <div v-else v-bind:class="`t`">
              推荐客户
            </div>

            <div v-if="setitem.status === 1 ||
              (setitem.status === 2 &&
                (setitem.jobCandidateStatusEVoList.length === 0 ||
                  (setitem.jobCandidateStatusEVoList.length > 0 &&
                    setitem.jobCandidateStatusEVoList[0].type !== 1))) ||
              setitem.status === 3 ||
              setitem.status === 99" v-bind:class="`t active close`" @click="passortg(1)">
              淘汰
            </div>
            <div v-else v-bind:class="`t`">
              淘汰
            </div>

            
            <div v-if="setitem.status === 1 ||
              (setitem.status === 2 &&
                (setitem.jobCandidateStatusEVoList.length === 0 ||
                  (setitem.jobCandidateStatusEVoList.length > 0 &&
                    setitem.jobCandidateStatusEVoList[0].type !== 1))) ||
              setitem.status === 3 ||
              setitem.status === 99" v-bind:class="`t active pass`" @click="passortg(2)">
              已面试
            </div>
            <div v-else v-bind:class="`t`">
              已面试
            </div>



            <div v-if="setitem.status === 4" v-bind:class="`t active`" @click="flag(5)">
              已发offer
            </div>
            <div v-if="setitem.status !== 4" v-bind:class="`t`">
              已发offer
            </div>

            <div v-if="setitem.status === 5" v-bind:class="`t active`" @click="flag(6)">
              已入职
            </div>
            <div v-if="setitem.status !== 5" v-bind:class="`t`">
              已入职
            </div>

            <div v-if="setitem.status === 6" v-bind:class="`t active`" @click="flag(7)">
              过保
            </div>
            <div v-if="setitem.status !== 6" v-bind:class="`t`">
              过保
            </div>
          </div>



          <div v-if="setitem.jobCandidateStatusEVoList.length > 0 &&
            setitem.status !== 99
            " class="zjzt">
            <div :class="setitem.jobCandidateStatusEVoList[0].type === 1
              ? 'topp1 close'
              : 'topp1 pass'
              ">
              {{
                setitem.jobCandidateStatusEVoList[0].type === 1
                ? '该简历已经被淘汰，可重新激活'
                : '该简历已经通过面试'
              }}
            </div>
            <div v-if="setitem.jobCandidateStatusEVoList[0].type === 1" class="topp2" @click="flag(99)">
              激活
            </div>
          </div>
          <div class="fkBox">
            <div class="title">反馈详情</div>
            <div class="tip" v-if="setitem.jobCandidateStatusEVoList.length <= 0">
              当前暂无反馈进度
            </div>
            <div class="tipbox" v-for="(item, index) in setitem.jobCandidateStatusEVoList" :key="index">
              <div class="boxtop">
                <div :class="item.type === 1 ? 'topp1 close' : 'topp1 pass'">
                  {{ item.type === 1 ? '被淘汰' : '通过面试' }}
                </div>
                <div class="topp2">
                  {{ moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') }}
                </div>
              </div>
              <div class="boxbottom">
                {{ item.cause }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="form.title" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item :label="form.par" :label-width="formLabelWidth">
          <el-input v-model="form.statusDes" autocomplete="off" :placeholder="'请输入' + form.par"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="passRes()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Config from '../config/index'
export default {
  name: 'myReceiveResume',
  props: {},
  data() {
    return {
      statusCount: [
        { status: 1, statusNum: 0 },
        { status: 2, statusNum: 0 },
        { status: 3, statusNum: 0 },
        { status: 4, statusNum: 0 },
        { status: 5, statusNum: 0 },
        { status: 6, statusNum: 0 },
        { status: 7, statusNum: 0 },
        { status: 99, statusNum: 0 }
      ],
      bannerlist: [],
      bannerLists: [],
      moment: moment,
      jobName: '全部职位',
      jobPageNum: 1,
      jobPageSize: 200,
      jobList: [],
      resumeStatus: '1',
      resumeList: [],
      resumePageNum: 1,
      resumePageSize: 5,
      resumePageTotle: 0,
      loading: false,
      setitem: false,
      setid: false,
      dialogFormVisible: false,
      form: {
        statusDes: '',
        statusOp: false,
        title: '',
        par: '',
        status: 2,
      },
      formLabelWidth: '120px',
      mwidth: {
        1: '75px',
        2: '225px',
        3: '375px',
        4: '525px',
        5: '675px',
        6: '825px',
        7: '910px',
        99: '75px',
      },
    }
  },
  watch: {},
  created: function () { },
  methods: {
    getstatusCount: function () {
      let that = this
      let data = {}
      if (
        that.jobName !== '' &&
        that.jobName !== 'all' &&
        that.jobName !== '全部职位'
      ) {
        data.jobId = that.jobName
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/getJobResumeSatusCount',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        },
        data: data
      }).then((res) => {
        if (res.data.success === '1') {
          debugger
          that.statusCount = res.data.content
        } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    goPage: function (url) {
      window.open(url, '_blank')
    },
    getBannerList: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getDictlist?type=banner_pa_da',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        }
      }).then((res) => {
        if (res.data.success === '1') {
          let demoList = res.data.content
          that.bannerlist = demoList
        } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getSmallBanner: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getDictlist?type=banner_pa_x',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        }
      }).then((res) => {
        if (res.data.success === '1') {
          let demoList = res.data.content
          that.bannerLists = demoList
        } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getJobList: function () {
      let that = this
      let data = {
        pageNum: that.jobPageNum,
        pageSize: that.jobPageSize,
        jobName: that.jobName === '全部职位' ? '' : that.jobName,
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/jobSearch',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          if (res.data.success === '1') {
            let demoListDelfuat = [
              {
                positionName: '全部职位',
                id: '',
                label: '全部职位',
                value: 'all',
              },
            ]
            for (let i in res.data.content.list) {
              ; (res.data.content.list[i].label = `${res.data.content.list[i].positionName
                }(${res.data.content.list[i].status === 1 ? '上线中' : '已下线'
                })`),
                (res.data.content.list[i].value = res.data.content.list[i].id)
            }
            let demoList = demoListDelfuat.concat(res.data.content.list)
            that.jobList = demoList
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    passortg(type) {
      this.form = {
        statusDes: '',
        statusOp: type,
        status: type === 1 ? 2 : 4,
        title: type === 1 ? '淘汰简历' : '通过简历',
        par: type === 1 ? '淘汰理由' : '通过理由',
      }
      this.dialogFormVisible = true
    },
    getResInfo: function (id) {
      let that = this
      that.setid = id
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/getResumeDes',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          candidateId: id,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.setitem = res.data.content
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    passRes() {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/flagStatus',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          candidateId: that.setid,
          status: that.form.status,
          statusDes: that.form.statusDes,
          statusOp: that.form.statusOp,
        },
      })
        .then((res) => {
          that.dialogFormVisible = false
          if (res.data.success === '1' || res.data.success === '01') {
            that.resumeStatus = that.form.status.toString()
            that.getResInfo(that.setid)
            that.getResumeList('no')
            that.getstatusCount()
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    flag(num) {
      let that = this
      if (
        (num === 2 && this.setitem.status === 1) ||
        (num === 3 && this.setitem.status === 2) ||
        (num === 5 && this.setitem.status === 4) ||
        (num === 6 && this.setitem.status === 5) ||
        (num === 7 && this.setitem.status === 6) ||
        num === 99
      ) {
      } else {
        return false
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/flagStatus',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          candidateId: that.setid,
          status: num,
          statusDes: '',
          statusOp: 0,
        },
      })
        .then((res) => {
          if (res.data.success === '1' || res.data.success === '01') {
            that.resumeStatus = num.toString()
            that.getResInfo(that.setid)
            that.getResumeList('no')
            that.getstatusCount()
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getResumeList: function (isGet = 'yes') {
      let that = this
      that.loading = true
      let data = {
        pageNum: that.resumePageNum,
        pageSize: that.resumePageSize,
        status:
          Number(that.resumeStatus) === 21 ? 2 : Number(that.resumeStatus),
      }
      if (
        that.jobName !== '' &&
        that.jobName !== 'all' &&
        that.jobName !== '全部职位'
      ) {
        data.jobId = that.jobName
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/getJobResume',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            for (let i = 0; i < res.data.content.list.length; i++) {
              res.data.content.list[i].visible2 = false
              res.data.content.list[i].visible3 = false
              res.data.content.list[i].visible4 = false
              res.data.content.list[i].xsTime = moment(
                res.data.content.list[i].createTime
              ).format('YYYY-MM-DD HH:mm:ss')
            }
            that.resumeList = res.data.content.list
            that.resumePageTotle = res.data.content.total
            if (res.data.content.list.length > 0 && isGet === 'yes') {
              that.getResInfo(res.data.content.list[0].id)
            }
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    selectJob: function (e) {
      this.jobName = e
      this.resumePageNum = 1
      this.getResumeList()
      this.getstatusCount()
    },
    changeResumeStatus: function (e) {
      this.resumeStatus = e
      this.resumePageNum = 1
      this.getstatusCount()
      this.getResumeList()
    },
    handleCurrentChange: function (e) {
      this.resumePageNum = e
      this.getstatusCount()
      this.getResumeList()
    },
    openPdf: function (url) {
      window.open(url, '_blank')
    },
    download: function (item) {
      fetch(
        item.oldFileUrl
      ).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          const name = `${item.positionName}-${item.customCompanyName}-${moment().format('YYYY-MM-DD-HH-mm-ss')}`
          a.style.display = 'none'
          a.href = blobUrl
          a.download = name
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(blobUrl)
        })
      })
    },
    lookPhone: function (item) {
      if (Number(item.isContactInformation) === 1) {
        this.$alert('候选人' + item.name + '联系方式：' + item.phone, '提示', {
          confirmButtonText: '确定',
        })
        return false
      }
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/getResumeLink',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          candidateId: item.id,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            this.$alert(
              '候选人' + item.name + '联系方式：' + item.phone,
              '提示',
              {
                confirmButtonText: '确定',
              }
            )
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    popover: function (index, flag, status) {
      let list = this.resumeList
      list[index]['visible' + flag] = false
      if (status) {
        this.flagResume(index, flag)
      }
    },
    flagResume: function (index, flag) {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/resume/flagStatus',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          candidateId: this.resumeList[index].id,
          resumeEnterpriseStatus: flag,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.resumeList[index].entryPersonStatus = flag
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
  },
  mounted: function () {
    this.getJobList()
    this.getResumeList()
    this.getBannerList()
    this.getSmallBanner()
    this.getstatusCount()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myReceiveResumeIndex {
  min-width: 100vw;
  flex: 1;
  padding-top: 1px;
  position: relative;
  background-color: #e6e6e6;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;

  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;

    .el-pager {
      li {
        background: transparent;
        color: #5dc2d0;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }

  .bannercont {
    width: 100vw;

    .banner1 {
      width: 97vw;
      height: 17vw;
      margin: 20px auto 0 auto;

      .imgg {
        width: 97vw;
        height: 17vw;
      }
    }

    .banner2 {
      width: 97vw;
      height: 7vw;
      margin: 20px auto 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .imgg {
        width: 21vw;
        height: 7vw;
        margin-right: 1.5vw;
      }
    }
  }

  .cont {
    width: 100vw;
    // overflow-x: scroll;
    height: calc(100%);
    border-radius: 8px;
    box-sizing: border-box;
    // overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .selectCont {
      width: 311px;
      background-color: #ffffff;
      box-sizing: border-box;
      margin-top: 30px;
      padding: 35px 22px;
      border-radius: 10px;
      margin-left: 20px;

      .el-select {
        width: 100%;
        background: #f2f2f2;
        border-radius: 5px;

        .el-input {
          color: #5dc2d0;

          .el-input__inner {
            background-color: transparent;
            border: none;
            color: #5dc2d0;

            &::-webkit-input-placeholder {
              color: #5dc2d0;
            }
          }

          .el-select__caret {
            color: #5dc2d0;
          }
        }
      }

      .el-radio-group {
        margin-top: 14px;
        border-top: 2px solid #cccccc;
        padding-top: 14px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .el-radio-button__inner {
          background-color: transparent;
          color: #cccccc;
          background-color: #f2f2f2;
          width: 117.4px;
          margin: 0 6px 21px 6px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .is-active {
          border: none;

          .el-radio-button__inner {
            background-color: #5dc2d0;
            color: #fff;
            border: none;
            border-radius: 5px;
          }
        }
      }

      .resitem {
        width: 262px;
        height: 77px;
        border-radius: 10px;
        border: 1px solid #5dc1cf;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        cursor: pointer;

        .p1 {
          font-size: 18px;
          color: #5dc1cf;
        }

        .p2 {
          font-size: 12px;
          color: #4d4d4d;
        }

        .p3 {
          font-size: 12px;
          color: #4d4d4d;
        }
      }

      .resitemactive {
        background-color: #5dc1cf;

        .p1 {
          font-size: 18px;
          color: #ffffff;
        }

        .p2 {
          font-size: 12px;
          color: #ffffff;
        }

        .p3 {
          font-size: 12px;
          color: #ffffff;
        }
      }
    }

    .tableCont {
      flex: 0.9;
      margin-top: 30px;
      box-sizing: border-box;
      background-color: #ffffff;
      margin-right: 20px;
      border-radius: 10px;
      padding: 30px;
      overflow-x: scroll;

      .name {
        font-size: 40px;
        font-weight: bold;
        padding: 30px 0;
      }

      .bt {
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
        height: 26px;
        line-height: 26px;
        border-left: 5px solid #5dc1cf;
        margin-bottom: 30px;
        margin-top: 30px;
      }

      .item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 0;

        .p1 {
          color: rgb(97, 93, 93);
          font-size: 14px;
        }

        .p2 {
          font-size: 14px;
          margin-left: 20px;
        }

        .p3 {
          font-size: 14px;
          margin-left: 20px;
          cursor: pointer;
          color: #5dc1cf;
        }
      }

      .linebox {
        width: 1440px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-top: 30px;

        .line {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 910px;
          height: 5px;
          background-color: #b9b9b9;
          position: relative;

          .dot {
            width: 10px;
            height: 10px;
            background-color: #b9b9b9;
            border-radius: 100%;
          }

          .drawline {
            width: 910px;
            height: 5px;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #5dc2d0;
          }
        }

        .textline {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 910px;
          position: relative;
          margin-top: 10px;

          .t {
            font-size: 12px;
            color: #b9b9b9;
          }
        }
      }

      .btnbox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 910px;
        margin: 20px auto 0 auto;

        .t {
          width: 120px;
          height: 36px;
          font-size: 18px;
          line-height: 36px;
          border-radius: 36px;
          background-color: #b9b9b9;
          color: #ffffff;
          text-align: center;
        }

        .active {
          background-color: #5dc2d0;
          color: #ffffff;
          cursor: pointer;
        }

        .close {
          background-color: red;
        }

        .pass {
          background-color: green;
        }
      }

      .zjzt {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 910px;
        margin: 30px auto 30px auto;

        .topp1 {
          color: #4d4d4d;
          font-size: 18px;
          font-weight: bold;
          margin-right: 20px;
        }

        .topp2 {
          width: 120px;
          height: 36px;
          font-size: 18px;
          line-height: 36px;
          border-radius: 36px;
          color: #ffffff;
          text-align: center;
          background-color: green;
          cursor: pointer;
        }

        .close {
          color: red;
        }

        .pass {
          color: green;
        }
      }

      .fkBox {
        width: 910px;
        padding: 30px;
        box-sizing: border-box;
        border-radius: 10px;
        background-color: #c0ac584d;
        margin: 30px auto;

        .title {
          color: #4d4d4d;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .tip {
          color: #4d4d4d;
        }

        .tipbox {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin: 30px 0 30px 0;

          .boxtop {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;

            .topp1 {
              color: #4d4d4d;
              font-size: 18px;
              font-weight: bold;
              margin-right: 20px;
            }

            .topp2 {
              color: #4d4d4d;
              font-size: 12px;
            }

            .close {
              color: red;
            }

            .pass {
              color: green;
            }
          }

          .boxbottom {
            margin-top: 20px;
            color: #4d4d4d;
          }
        }
      }
    }
  }
}
</style>
